import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { PanelInstrucionHands } from '../../../components/common/PanelInstrucionHands';
import { imgInstructionTeam2 } from '../../../assets/imgIntruction/tema2';
import { ModalInfoTextV2 } from '../../../components/common/ModalInfoTextV2';
import { imgTema2 } from '../../../assets/tema2';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivity: 2,
	dialogTwo: 3,
	panelInstruction: 4,
	panelMaquinaCafe: 5,
	panelMaquinaCapuchino: 6,
	panelMaquinaKobalto: 7,
	panelMaquinaKrea: 8,
	panelMaquinaYelox: 9,
	win: 10,
};


export const Team2SubtopicTwoActivityEight = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 8);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 8');
			ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 8);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act8_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicTwo.clickedRayCaster, (name) => {
		switch (name) {
			case "Yelox":
				setUiToShow(steps.panelMaquinaYelox)
				break;
			case "Cafetera_Krea":
				setUiToShow(steps.panelMaquinaKrea)
				break;
			case "Cafetera_2":
				setUiToShow(steps.panelMaquinaCafe)
				break;
			case "Cafetera_1":
				setUiToShow(steps.panelMaquinaKobalto)
				break;
			case "Cafetera_3":
				setUiToShow(steps.panelMaquinaCapuchino)
				break;
			default:
				break;
		}
	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 8);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 8: Conoce las máquinas de café de tu tienda." />
					<DialogBarNew
						dialog={
							"¡Bien! Es momento de repasar y revisar lo visto de cada una de nuestras máquinas de café."
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivity);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act8_a02T2)
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Identifica un máximo de tres cafeteras que se encuentren en tu entorno laboral. Selecciónalas para desplegar información sobre ellas."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.moveTable)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelInstruction);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelInstruction && (
				<>
					<PanelInstrucionHands
						text="Toca sobre los objetos para obtener información."
						action={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.checkMachine, "Yelox")
							setUiToShow(-2);
						}}
						img={imgInstructionTeam2.team2_sub2_act_8_01}
					/>
				</>
			)}

			{uiToShow === -2 && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}

			{uiToShow === steps.panelMaquinaCafe && (
				<>
					<ModalInfoTextV2
						title="Máquina de café Americano."
						description={`Contamos con 4 versiones de café: Clásico, descafeinado, mezclas mexicanas e intenso. Los tamaños que manejamos son:Mediano (12oz), grande (16 oz) y  jumbo (20 oz)`}
						url={imgTema2.CafeAmericano}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.checkMachine, "Cafetera_1")
							setUiToShow(-1);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.panelMaquinaCapuchino && (
				<>
					<ModalInfoTextV2
						title="Máquina de Capuchino."
						description={`Contamos con 10 tipos de capuchinos:
						Regular, Vainilla, Moka, Canela, Chocolate, Latte, Splenda, Hershey's, Sin Azúcar y Té Chai.
						Recuerda que para evitar tirar producto al rellenar la máquina de capuchino es necesario rellenar los contenedores fuera de la máquina girando el codo servidor
						hacia arriba.
						`}
						url={imgTema2.CafeCapuchino}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.checkMachine)
							setUiToShow(steps.win);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.panelMaquinaKobalto && (
				<>
					<ModalInfoTextV2
						title="Máquina de Kobalto."
						description={`
						Contamos con un vaso exclusivo para esta máquina, la principal característica de
						este vaso es su particular color blanco.

						Para el café y la leche contamos con la cantidad mínima de 250g y para la cantidad
						máxima es de 1000g.
						Para el chocolate contamos con la cantidad mínima de 140 y para la cantidad
						máxima es de 560g.
						`}
						url={imgTema2.CafeKobalto}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.checkMachine, "Cafetera_3")
							setUiToShow(-1);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.panelMaquinaKrea && (
				<>
					<ModalInfoTextV2
						title="Máquina de Krea."
						description={`Si los contenedores y embudos están sucios, debemos esperara al mantenimiento
						que realizará Caffeino.
						
						Recuerda que para rellenar el contenedor de granos debes de utilizar la llave con la
						que abres la máquina, levantar la tapa y rellenar de café de grano regular.`}
						url={imgTema2.CafeKrea}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.checkMachine, "Cafetera_2")
							setUiToShow(-1);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}
			{uiToShow === steps.panelMaquinaYelox && (
				<>
					<ModalInfoTextV2
						title="Máquina de Yelox (Frappé)."
						description={`Es importante mantener la temperatura de -3 grados centígrados.
						El Frappé tiene una vida total de 7 días, siempre coloca el banderín de cuando se
						colocó.`}
						url={imgTema2.CafeYelox}
						callback={() => {
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityEight.checkMachine, "Cafetera_Krea")
							setUiToShow(-1);
						}}
					>
					</ModalInfoTextV2>
				</>
			)}

			{uiToShow === steps.win && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={15}
					dialogModal="Es importante conocer cada máquina de café dentro de la Tienda."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 8,
								pointsWin: 15,
								subtema: tasksId.tema2.activities.subtema2,
							})
						);
						navigator("/home2/tema2/subtema2/activityresult");
					}}
				/>
			)}
		</>
	)
}
